/**
 * @generated SignedSource<<6ee6127fab56f4c24c4d90bc8b99492e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignOrgRoleInput = {
  adminId: string;
  applicationId?: string | null | undefined;
  organizationId: string;
  roleId?: string | null | undefined;
  roleName?: string | null | undefined;
};
export type useAdminMutationsAssignOrgRoleMutation$variables = {
  input: AssignOrgRoleInput;
};
export type useAdminMutationsAssignOrgRoleMutation$data = {
  readonly assignOrgRole: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
      readonly vars: any | null | undefined;
    }>;
    readonly result: {
      readonly adminId: string;
      readonly id: string;
      readonly organizationId: string;
      readonly role: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly roleId: string;
    } | null | undefined;
  };
};
export type useAdminMutationsAssignOrgRoleMutation = {
  response: useAdminMutationsAssignOrgRoleMutation$data;
  variables: useAdminMutationsAssignOrgRoleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssignOrgRoleResult",
    "kind": "LinkedField",
    "name": "assignOrgRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminOrganizationRole",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "organizationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roleId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vars",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdminMutationsAssignOrgRoleMutation",
    "selections": (v2/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAdminMutationsAssignOrgRoleMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "331fce2cfe666c04e156d60f28d106a0",
    "id": null,
    "metadata": {},
    "name": "useAdminMutationsAssignOrgRoleMutation",
    "operationKind": "mutation",
    "text": "mutation useAdminMutationsAssignOrgRoleMutation(\n  $input: AssignOrgRoleInput!\n) {\n  assignOrgRole(input: $input) {\n    result {\n      id\n      adminId\n      organizationId\n      roleId\n      role {\n        id\n        name\n      }\n    }\n    errors {\n      message\n      fields\n      code\n      shortMessage\n      vars\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "df364b9b063e5238d38cc352e57b3d0b";

export default node;
